import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M15.859 15.859 21 21m-3.163-10.581a7.419 7.419 0 1 1-14.837 0 7.419 7.419 0 0 1 14.837 0Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnSearch;
